import React, { Component, useState, useRef } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover,Overlay } from 'react-bootstrap'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
 
import { InputText } from 'primereact/inputtext';
import FeatherIcon from 'feather-icons-react';

class BasicTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            globalSearchBox: '',
            data: this.props.data,
            columns: this.props.columns,
            PageSize:10
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        console.log(e.target.value);
        this.setState(
            { [e.target.name]: e.target.value }
        )
    }
    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data})
      }

    render() {
        return (
                <Card>
                    <Card.Body>
                        <DataTable className="Table" value={this.state.data} paginator rows={this.state.PageSize} sortMode="multiple" globalFilter={this.state.globalSearchBox} scrollable >
                            {
                                this.state.columns != null ?
                                
                                
                                    this.state.columns.map(
                                    (item, index) => (
                                        <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>)
                                    )
                                
                                :
                                <div></div>

                                
                            }
                        </DataTable>
                    </Card.Body>
                </Card>

        );
    }
}

export default BasicTable;


